import styled from 'styled-components';
import {StrategyPageHeader} from '../Strategy/styles';

/** Cabeçalho da página (título + ícone) */
export const CalendarPageHeader = styled(StrategyPageHeader)`
    margin-bottom: 0 !important;
`;

export const CalendarStack = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    align-items: stretch;
    gap: 44px;

    @media (min-width: 768px) {
        gap: 60px;
    }
`;

export const CalendarPageInner = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: stretch;
`;

/** Card do calendário mais estreito que o StrategyWideCardColumn global (1100px) */
export const CalendarCardColumn = styled.div`
    width: 100%;
    max-width: 780px;
    margin-left: auto;
    margin-right: auto;
    position: relative;
    z-index: 2;
    margin-top: 16px;

    @media (min-width: 576px) {
        margin-top: 20px;
    }

    @media (min-width: 992px) {
        margin-top: 24px;
    }
`;

/** Área de abas — mesmo padrão de /trading/report-performance */
export const CalendarTabsArea = styled.div`
    padding: 4px 0 8px;
    color: rgba(232, 234, 255, 0.92);

    @media (min-width: 768px) {
        padding: 8px 0 12px;
    }

    .nav-tabs-calendar {
        border-bottom: 1px solid rgba(242, 146, 5, 0.22);
        flex-wrap: wrap;
        gap: 6px;
        margin-bottom: 0;
    }

    .nav-tabs-calendar .nav-item {
        margin-bottom: 0;
    }

    .nav-tabs-calendar .nav-link {
        color: rgba(200, 210, 230, 0.88) !important;
        border: 1px solid transparent !important;
        border-radius: 10px 10px 0 0;
        padding: 10px 14px;
        font-weight: 600;
        font-size: 13px;
        transition: all 0.2s ease;
        background: transparent !important;
    }

    .nav-tabs-calendar .nav-link:hover {
        color: #ffffff !important;
        background: rgba(242, 146, 5, 0.1) !important;
        border-color: rgba(242, 146, 5, 0.25) !important;
    }

    .nav-tabs-calendar .nav-link.active {
        color: #f29205 !important;
        background: rgba(242, 146, 5, 0.14) !important;
        border-color: rgba(242, 146, 5, 0.4) !important;
        border-bottom-color: transparent !important;
        box-shadow: 0 -2px 14px rgba(242, 146, 5, 0.12);
    }

    .tab-content {
        color: #e8eaf4;
        padding-top: 1.25rem;
    }

    .tab-pane {
        animation: calendarTabFade 0.25s ease;
    }

    @keyframes calendarTabFade {
        from {
            opacity: 0;
        }
        to {
            opacity: 1;
        }
    }
`;

/** Legenda de volatilidade (substitui alert Bootstrap) */
export const CalendarLegendList = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
    margin-bottom: 20px;
`;

export const CalendarLegendItem = styled.div`
    display: flex;
    align-items: flex-start;
    gap: 12px;
    padding: 12px 14px;
    border-radius: 12px;
    background: rgba(242, 146, 5, 0.06);
    border: 1px solid rgba(242, 146, 5, 0.2);
    color: rgba(230, 235, 250, 0.95);

    img {
        flex-shrink: 0;
        margin-top: 2px;
    }

    strong,
    b {
        color: #f29205;
        font-weight: 700;
    }

    small {
        display: block;
        margin-top: 4px;
        color: rgba(180, 195, 220, 0.88);
        line-height: 1.45;
    }
`;

export const CalendarInfoNote = styled.p`
    margin: 0 0 20px;
    font-size: 13px;
    color: rgba(180, 195, 220, 0.9);
    line-height: 1.5;

    i {
        color: #f29205;
        margin-right: 6px;
    }
`;

/** Área que recebe o iframe escalado (altura = 467 * scale; conteúdo centralizado) */
export const CalendarIframeScaleRoot = styled.div`
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    overflow: hidden;
    -webkit-overflow-scrolling: touch;
    border-radius: 12px;
    border: 1px solid rgba(242, 146, 5, 0.15);
    background: rgba(8, 12, 28, 0.6);
    padding: 0;
    box-sizing: border-box;
    line-height: 0;
`;

/** Recorta o layout 650×467 após scale (evita overflow horizontal) */
export const CalendarIframeScaleClip = styled.div`
    flex-shrink: 0;
    overflow: hidden;
    line-height: 0;
`;

/** Wrapper interno fixo 650×467 + transform: scale (ver InvestingCalendarEmbed.js) */
export const CalendarIframeScaleInner = styled.div`
    transform-origin: top left;
    display: block;
    margin: 0;
    padding: 0;

    iframe {
        display: block;
        border: 0;
        margin: 0;
        padding: 0;
        vertical-align: top;
        pointer-events: auto;
    }
`;

export const ContainerNews = styled.div`
    width: 100%;
    max-width: 100%;

    .legend ul {
        list-style-type: none;
    }

    .poweredBy {
        margin-top: 16px;
        padding-top: 12px;
        border-top: 1px solid rgba(255, 255, 255, 0.08);

        span {
            font-size: 0.85rem;
            color: rgba(200, 210, 230, 0.85);
            line-height: 1.5;

            .underline_link {
                padding-left: 5px;
                color: #00d4ff;
                font-weight: 600;
                text-decoration: none;
                transition: color 0.2s ease;

                &:hover {
                    color: #f29205;
                }
            }
        }
    }
`;
